export const environment = {
  production: true,
  apiUrl: 'https://africayouthactivism.org:8443/tuwindiSiteRest/api/'
};
